
export function equalizeHeights(equalizeSection) {
    var heights = equalizeSection.map(function() {
        $(this).height('auto');
        return $(this).height();
    }).get();
    var maxHeight = Math.max.apply(null, heights);
    equalizeSection.height(maxHeight);
}
